import { useSyncExternalStore } from "react"

/*
 * Whether a media query matches, as an external store: no state set from an
 * effect, one listener per query, and `false` on the server. The ground and
 * the console layout read the `lg` breakpoint through this so nothing is
 * mounted or moved for a viewport that does not show it.
 */
export function useMedia(query: string) {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query)
      list.addEventListener("change", onChange)
      return () => list.removeEventListener("change", onChange)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}

/** Tailwind's `lg` — the width at which the rail is a rail and the ground is drawn. */
export const LG = "(min-width: 64rem)"
